import { forwardRef } from "react";

const ModelProvider = forwardRef(
  ({ id, getter, att_name, View, ...props }, ref) => {
    const { data, status } = getter(id);

    if (status == "error") return <>Error</>;
    if (status != "success") return <></>;
    return <View ref={ref} {...{ [att_name]: data, ...props }} />;
  },
);

export default ModelProvider;
